'use client';

import NextBaseImage, { ImageProps } from 'next/legacy/image';

const StorybookNextImage: React.FC<ImageProps> = (props: any) => (
  <NextBaseImage
    {...props}
    loader={({ src }) => {
      return src;
    }}
    unoptimized
  />
);
const isStorybook = process.env.STORYBOOK_IS_STORYBOOK === 'true';

// github.com/vercel/next.js/issues/18393
const NextImage = !isStorybook ? NextBaseImage : (StorybookNextImage as typeof NextBaseImage);

export default NextImage;
